import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';

const PharmacistRoute = ({ roles, component: Component, ...rest }) => (
    <Route
        {...rest}
        render={props =>
            roles[0] === "PHARMACIST" ? (<Component {...props} />) : (<Redirect to ={{pathname: "/login", state: {from: props.location}}} />)}
    />
);

PharmacistRoute.propTypes = {
    component: PropTypes.func.isRequired,
    roles: PropTypes.array.isRequired
};

const mapStateToProps = (state) => ({
    roles: state.auth.user.roles
});

export default connect(mapStateToProps)(PharmacistRoute);
